/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
};

const NotepadIcon: FC<IProps> = ({ width = 24, height = 24 }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="shrink-0 mt-0.5">
    <path d="M8 2V5" stroke="#262626" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 2V5" stroke="#262626" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M16 2V5" stroke="#262626" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M4 4H20V20C20 20.5304 19.7893 21.0391 19.4142 21.4142C19.0391 21.7893 18.5304 22 18 22H6C5.46957 22 4.96086 21.7893 4.58579 21.4142C4.21071 21.0391 4 20.5304 4 20V4Z" stroke="#262626" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8 10H10" stroke="#262626" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8 14H16" stroke="#262626" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8 18H14" stroke="#262626" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default NotepadIcon;
